const isValidURL = (url) => {
    const urlRegex = /^[^\s]+\.(com|org|net|edu|gov|biz|info|in|us|uk|co|io|me|tv|xyz)$/i;
    return urlRegex.test(url);
}

export default isValidURL;